import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * Stub replacement for MsalService when running in offline mode.
 * Provides a fake account so that components relying on MSAL still work.
 */
@Injectable({ providedIn: 'root' })
export class MockMsalService {
    private readonly devUser = (environment as any).devUser ?? {
        name: 'Dev User',
        email: 'dev@alpconnex.local',
        localAccountId: '00000000-0000-0000-0000-000000000001',
    };

    instance = {
        getActiveAccount: () => ({
            name: this.devUser.name,
            username: this.devUser.email,
            localAccountId: this.devUser.localAccountId,
            homeAccountId: this.devUser.localAccountId,
            environment: 'offline',
            tenantId: 'offline',
            idTokenClaims: { roles: [] },
        }),
        getAllAccounts: () => [this.instance.getActiveAccount()],
        setActiveAccount: (_account: any) => { },
    };

    acquireTokenSilent(_request: any): Observable<any> {
        return of({ accessToken: 'offline-dev-token' });
    }

    logoutRedirect(): void {
        console.warn('[Offline Mode] Logout is not available in offline mode.');
    }

    loginRedirect(): Observable<void> {
        return of(undefined);
    }
}

/**
 * Stub replacement for MsalGuard. Always allows navigation.
 */
@Injectable({ providedIn: 'root' })
export class MockMsalGuard {
    canActivate(): boolean {
        return true;
    }
}

/**
 * Stub replacement for MsalBroadcastService. Provides empty observables.
 */
@Injectable({ providedIn: 'root' })
export class MockMsalBroadcastService {
    msalSubject$ = of();
    inProgress$ = of();
}
